import { render, staticRenderFns } from "./SegmentList.vue?vue&type=template&id=c6ac2ee6&scoped=true&"
import script from "./SegmentList.vue?vue&type=script&lang=js&"
export * from "./SegmentList.vue?vue&type=script&lang=js&"
import style0 from "./SegmentList.vue?vue&type=style&index=0&id=c6ac2ee6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ac2ee6",
  null
  
)

export default component.exports